import { SubscriptionConcept } from "src/api-service";

// **************************************************************************
// SUBSCRIPTION CONCEPT STATE
// **************************************************************************
export interface SubscriptionConceptState {
    subscriptionConcept: SubscriptionConcept | null;
    subscriptionConcepts: SubscriptionConcept[];
    subscriptionConceptsLoading: boolean;
}

export const initialSubscriptionConceptState: SubscriptionConceptState = {
    subscriptionConcept: null,
    subscriptionConcepts: [],
    subscriptionConceptsLoading: false,
};
